export default __webpack_public_path__ + "static/media/before-trip-5.3b4a1869.svg";